import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiPopover-paper': {
      width: 440,
    },
  },
  popoverXS: {
    display: 'flex',
    alignItems: 'flex-end',
    '& .MuiPopover-paper': {
      position: 'relative',
      width: '100%',
      height: '100vh',
      maxWidth: '100%',
      maxHeight: '100%',
      top: 'inherit !important',
      left: 'inherit !important',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 0,
    },
  },
  dialogTitle: {
    position: 'sticky',
    top: 0,
    zIndex: theme.zIndex.modal,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1, 2, 1, 4),
    backgroundColor: theme.palette.primary.lighter,
    '& .MuiTypography-root': {
      fontWeight: 600,
    },
  },
  titleText: {
    color: theme.palette.primary.dark,
  },
  dialogClose: {
    color: theme.palette.primary.dark,
  },
  dialogContent: {
    width: '100%',
    margin: 0,
    padding: theme.spacing(2, 0),
    [theme.breakpoints.up('sm')]: {
      width: 440,
      height: 533,
    },
    '& > div': {
      width: 'auto',
    },
  },
  dialogActions: {
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `solid 1px ${theme.palette.primary.lighter}`,
    backgroundColor: theme.palette.common.white,
    zIndex: theme.zIndex.modal,
    minHeight: theme.spacing(8),
    padding: theme.spacing(2),
  },
}))

export default useStyles
